import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['section']

  initialize () {
    this.escapeKeyCallback = this.handleEscapeKey.bind(this)
  }

  connect () {
    setTimeout(() => {
      this.element.classList.remove('modal--initial')
    }, 10) // Delay the removal to ensure the modal animates correctly;

    setTimeout(() => {
      this.disableWindowScrolling()
    }, 310) // This is the css animation time

    document.addEventListener('keyup', this.escapeKeyCallback)
  }

  disconnect () {
    document.removeEventListener('keyup', this.escapeKeyCallback)
  }

  // ---- Actions ---- //
  close () {
    this.element.classList.add('modal--closed')
    this.enableWindowScrolling()

    setTimeout(() => {
      this.element.remove()
    }, 315)
  }

  previousSection (e) {
    const current = e.target.closest('[data-target=\'modal.section\']')
    const back = this.sectionTargets[this.sectionTargets.indexOf(current) - 1]

    const title = current.dataset.dialogTitle
    if (title) this.setTitle(title)

    current.classList.add('hidden')
    back.classList.remove('hidden')
  }

  nextSection (e) {
    const skip = e.currentTarget.dataset.sectionSkip || 0
    const current = e.target.closest('[data-target=\'modal.section\']')
    const next = this.sectionTargets[this.sectionTargets.indexOf(current) + 1 + Number(skip)]

    const title = current.dataset.dialogTitle
    if (title) this.setTitle(title)

    current.classList.add('hidden')
    next.classList.remove('hidden')
  }

  // ---- Event Handlers ---- //
  handleEscapeKey (e) {
    if (e.key === 'Escape') this.close()
  }

  // ---- Support ---- //
  disableWindowScrolling () {
    if (this.element.classList.contains('modal--closed')) return

    this.y = window.scrollY
    this.x = window.scrollX

    document.body.classList.add('noscroll')
  }

  enableWindowScrolling () {
    document.body.classList.remove('noscroll')
    window.scrollTo(this.x, this.y)
  }
}
